// @ vendors
const Immutable = require('immutable');

// @ constants
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP, FIFTH_STEP } = require('constants/index');
const { FLOW_STEPS, WIZARD_REQUEST_RESPONSE_OPTIONS } = require('../../insuranceConstants/insuranceRequestHome');
const actionTypes = require('../../insuranceConstants/actionTypes');

// @ reducers
const insuranceRequestRelatedWizardStep1 = require('./insuranceRequestRelatedWizardStep1');
const insuranceRequestRelatedWizardStep2 = require('./insuranceRequestRelatedWizardStep2');
const insuranceRequestRelatedWizardStep3 = require('./insuranceRequestRelatedWizardStep3');
const insuranceRequestRelatedWizardStep4 = require('./insuranceRequestRelatedWizardStep4');
const insuranceRequestRelatedWizardStep5 = require('./insuranceRequestRelatedWizardStep5');

const stepsReducerList = [
    insuranceRequestRelatedWizardStep1,
    insuranceRequestRelatedWizardStep2,
    insuranceRequestRelatedWizardStep3,
    insuranceRequestRelatedWizardStep4,
    insuranceRequestRelatedWizardStep5
];

const setInitialState = () => {
    return Immutable.Map().merge({
        steps: stepsReducerList.map(reducer => reducer(undefined, { type: null })),
        isFetching: false,
        visibleStep: 1,
        error: '',
        wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS.NO_PROCESS,
    });
};

const updateStep = (steps, stepNumber, action) => {
    return steps.update(stepNumber, step => {
        return stepsReducerList[stepNumber](step, action);
    });
};

const insuranceRequestRelatedWizard = (state = setInitialState(), action) => {
    let step;
    let partialSteps;
    let visibleStep;
    switch (action.type) {
        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_LOAD_STEP:
            step = action.data.step;
            return state.merge({
                steps: updateStep(state.get('steps'), step, action),
                visibleStep: FLOW_STEPS[action.data.flowData.uiStep],
            });
        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_SET_VISIBLE_STEP:
            step = action.data.step;
            return state.merge({
                steps: updateStep(state.get('steps'), step - 1, action),
                visibleStep: step
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_VALIDATE_STEP:
            step = action.data.step;
            partialSteps = updateStep(state.get('steps'), step - 1, action);
            const sizeOfWizardSteps = partialSteps.size;
            visibleStep = partialSteps.getIn([step - 1, 'valid']) ? step + 1 : step;
            visibleStep = visibleStep > sizeOfWizardSteps ? sizeOfWizardSteps : visibleStep;
            return state.merge({
                steps: partialSteps,
                visibleStep
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_SET_DATA:
        case actionTypes.INSURANCE_REQUEST_RELATED_POST_APPRAISAL_WIZARD_SET_DATA:
            step = action.data.step;
            delete action.data['step'];
            return state.merge({
                steps: updateStep(state.get('steps'), step, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_SET_MIN_CONTINENT_VALUE:
        case actionTypes.INSURANCE_REQUEST_CHANGE_ERROR_POSTAL_CODE:
        case actionTypes.INSURANCE_REQUEST_CHANGE_ERROR_POPULATION:
        case actionTypes.INSURANCE_REQUEST_CLEAR_POSTAL_CODE_ERROR:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_SELECT_POPULATION_SUCCESS:
            return state.merge({
                steps: updateStep(state.get('steps'), SECOND_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_QUOTATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_SELECT_PLAN_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_SELECT_BASIC_PLAN:
        case actionTypes.INSURANCE_REQUEST_RELATED_SELECT_PLAN_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_SELECT_PLAN_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_COVERAGES_AND_PLANS_TABLE_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_BASIC_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_MEDIUM_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_HIGH_DATA_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_COVERAGES_DETAIL_DATA_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_CANCEL_SIMULATION_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_CANCEL_SIMULATION_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_CANCEL_SIMULATION_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_SET_LINKING_SUCCESS_TO_INITIAL:
        case actionTypes.INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_INITIAL_VALUE_IN_SUCCESS:
            return state.merge({
                steps: updateStep(state.get('steps'), THIRD_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_SIMULATION_LINK_S3_CLIENT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_SELECTED_PLAN:
            partialSteps = updateStep(state.get('steps'), SECOND_STEP, action);
            partialSteps = updateStep(partialSteps, THIRD_STEP, action);
            return state.merge({
                steps: partialSteps
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_PRICING_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_PRICING_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_PRICING_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_FAILURE:
            return state.merge({
                steps: updateStep(state.get('steps'), FOURTH_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_SAVE_STEP_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_SAVE_STEP_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_SAVE_STEP_FAILURE:
            step = action.data.step;
            partialSteps = updateStep(state.get('steps'), step, action);

            return state.merge({
                steps: partialSteps,
                visibleStep: partialSteps.getIn([step, 'valid']) ? step + 2 : step + 1
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_GET_DOCUMENT_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_DOCUMENT_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_GET_DOCUMENT_FAILURE:
        case actionTypes.INSURANCE_REQUEST_RELATED_SEND_BUDGET_EMAIL_REQUEST:
        case actionTypes.INSURANCE_REQUEST_RELATED_SEND_BUDGET_EMAIL_SUCCESS:
        case actionTypes.INSURANCE_REQUEST_RELATED_SEND_BUDGET_EMAIL_FAILURE:
        case actionTypes.SHOW_PRINT_REQUIRED:
            return state.merge({
                steps: updateStep(state.get('steps'), FIFTH_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_POST_WIZARD_SUCCESS:
            const { response } = action.data;
            return state.merge({
                wizardRequestResponse: WIZARD_REQUEST_RESPONSE_OPTIONS[response],
                insuranceIsBeingModified: false
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_CLEAR:
            return setInitialState();

        case actionTypes.INSURANCE_REQUEST_RELATED_SET_AGREEMENT_CHECKBOX:
            return state.merge({
                steps: updateStep(state.get('steps'), FIFTH_STEP, action)
            });

        case actionTypes.INSURANCE_REQUEST_RELATED_WIZARD_RESET_STEP:
            step = action.data.step;
            return state.merge({
                steps: updateStep(state.get('steps'), step -1, action),
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestRelatedWizard;
